// extracted by mini-css-extract-plugin
export default {"ui_kit_tabs":"tabs_ui_kit_tabs__r1ubo","ui_kit_tabs_item":"tabs_ui_kit_tabs_item__bKjLS","ui_kit_tabs_item_selected":"tabs_ui_kit_tabs_item_selected__JGS08"};